module.exports = __webpack_public_path__ + "static/media/left_ailgn_03.155e4cf4.jpeg";